module.exports = __webpack_public_path__ + "img/person-chalkboard-solid 1.2abfe670.svg";